//Client-side modal

'use client'

import { SelectedFilter, toQuery } from "../api/dashboard";
//import Error from "next/error";
//import { useRouter, useSearchParams } from "next/navigation";
import { FormEvent, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
interface ModalProps {
    url: string
}
const Modal = ({ url }: ModalProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [error, setError] = useState<string[] | null>(null);
    const [success, setSuccess] = useState<boolean>(false)
    //const router = useRouter();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    let params = [] as SelectedFilter[];
    searchParams.forEach((value, key) => {
        if (!value) {
            return;
        }
        if (key == "show") {
            return;
        }
        params.push({ name: key, value });

    });

    interface IDictionary {
        [index: string]: any;
    }
    async function onSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault()
        setIsLoading(true)
        setError(null) // Clear previous errors when a new request starts

        try {
            const formData = new FormData(event.currentTarget);


            formData.append("Filter", JSON.stringify(params));
            var object = {} as IDictionary;
            formData.forEach((value, key) => object[key] = value);

            var json = JSON.stringify(object);


            const response = await fetch(`${process.env.REACT_APP_API_HOST}Dashboard/CustomReport`, {
                method: 'POST',
                body: json,

                mode: "cors",
                headers: { "content-type": "application/json" }
            })

            if (!response.ok) {
                if (response.status == 400) {
                    const body = await response.json();
                    let errorList = [] as string[];
                    if (body.errors) {
                        for (const key in body.errors) {
                            errorList.push(body.errors[key]);
                        }
                        //body.errors.map((e) => errorList.push(e)  );
                    } else {
                        errorList.push(body.title);
                    }
                    setError(errorList);
                    return;

                }

                throw new Error('Failed to submit the data. Please try again.');
            }
            if (response.status == 202) {
                setSuccess(true);
            }
            // ...
        } catch (error) {
            const e = error as Error;
            // Capture the error message to display to the user
            setError([e.message]);
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    }
    if (success) {
        return (
            <div className="" >
                <div className="">
                    <div className="text-center">
                        <h3 className="">Request Custom Report</h3>

                        <div className="">
                            <p className="">Thank you for your request. You will hear from us shortly.</p>
                        </div>
                        <div>

                        </div>
                        <div className="">
                            <button type="button" onClick={() => navigate(`${url}?${toQuery(params)}show=false`)} className="button">Close</button>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
    let errors = null;
    if (error) {
        if (error.length == 1) {
            errors = (<>{error[0]}</>);
        } else if (error.length > 1) {
            errors = (<ul>{error.map((e, i) => (<li key={i}>{e}</li>))}</ul>);
        }

    }
    return (
        <div className="mt-4">
            <div className="">
                <div className="">
                    <h3 className="">Request Custom Report</h3>

                    <div className="">
                        <p className="">If you have a research question that cannot be answered using the dashboard filters, please submit a request for a Custom Report. Due to time and budget constraints, we may not be able to respond to all requests. Thank you for your understanding.</p>
                    </div>
                    <div>
                        <form onSubmit={onSubmit}>
                            <div className="">


                                <div className="">
                                    <div className="">
                                        <div className="">
                                            <label htmlFor="first-name" className="">First Name</label>
                                            <div className="">
                                                <input type="text" name="FirstName" id="first-name" autoComplete="given-name" className="" placeholder="First Name" />
                                            </div>
                                        </div>

                                        <div className="">
                                            <label htmlFor="last-name" className="">Last Name</label>
                                            <div className="">
                                                <input type="text" name="LastName" id="last-name" autoComplete="family-name" className="" placeholder="Last Name" />
                                            </div>
                                        </div>

                                        <div className="">
                                            <label htmlFor="organization" className="">Organization</label>
                                            <div className="">
                                                <input id="organization" name="Organization" type="text" autoComplete="organization" className="" placeholder="Organization" />
                                            </div>
                                        </div>
                                        <div className="">
                                            <label htmlFor="title" className="">Job Title</label>
                                            <div className="">
                                                <input id="title" name="JobTitle" type="text" autoComplete="title" className="" placeholder="Job TItle" />
                                            </div>
                                        </div>
                                        <div className="">
                                            <label htmlFor="email" className="">Email Address</label>
                                            <div className="">
                                                <input id="email" name="EmailAddress" type="email" autoComplete="email" className="" placeholder="Email Address" />
                                            </div>
                                        </div>


                                        <div className="">
                                            <label htmlFor="about" className="">Please provide your research question and an explanation of how and where the data requested will be used.</label>
                                            <div className="">
                                                <textarea name="Notes" id="about" rows={3} className="" placeholder="Please provide your research question and an explanation of how and where the data requested will be used."></textarea>
                                            </div>
                                        </div>


                                    </div>
                                </div>


                            </div>

                            <div className="">
                                <button type="button" onClick={() => navigate(`${url}?${toQuery(params)}show=false`)} className="button">Cancel</button>
                                <button type="submit" className="button ml-4">Send</button>
                            </div>
                        </form>
                    </div>
                    <div className="">
                        <div>
                            {errors && <div style={{ color: 'red' }}>
                                {errors}
                            </div>}

                        </div>

                        {/* Using useRouter to dismiss modal*/}
                        {/* <button
                            onClick={router.back}
                            className="px-4 py-2 bg-blue-500 text-white text-base font-medium rounded-md shadow-sm hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-300"
                        >
                            Close
                        </button> */}

                    </div>
                </div>
            </div>
        </div>
    );
}
export default Modal;